import Vue from 'vue'
import api from '../../api/api'

const bigPhase = {
  state: {
    list: []
  },

  mutations: {
    SET_BIGPHASE_LIST(state, data) {
      state.list = data || []
    }
  },

  actions: {
    async getBigPhaseList({ commit, rootState}) {
      let ret = await api.getPhase()
      commit('SET_BIGPHASE_LIST', ret.data)
      console.log('大阶段信息', ret)
    }
  }

};

export default bigPhase


// WEBPACK FOOTER //
// ./src/store/modules/bigPhase.js